import { Tooltip } from '@pepper/ui'

import styles from '../_.module.css'

type ServiceCardProps = {
  icon:
    | {
        blue: string
        gray: string
        default: string
      }
    | undefined
  title: string
  description: string
  id: number
  handleClick: (id: number) => void
}

const ServiceCard = ({
  icon,
  title,
  description,
  id,
  handleClick,
}: ServiceCardProps): JSX.Element => {
  return (
    <div
      className={styles.serviceCard}
      data-verticalId={id}
      onClick={() => handleClick(id)}
      aria-hidden="true"
      onKeyDown={() => handleClick(id)}
    >
      <img src={icon?.blue || ''} alt={title} />

      <div className={styles.serviceCardBody}>
        <h3>
          <Tooltip title={title} placement="bottom">
            {title}
          </Tooltip>
        </h3>
        <p>
          <Tooltip title={description} placement="bottom">
            {description}
          </Tooltip>
        </p>
      </div>
    </div>
  )
}

export default ServiceCard
